import React from 'react';

interface ServiceGapsCardProps {
  gaps: string[];
  maxItems?: number;
}

const ServiceGapsCard: React.FC<ServiceGapsCardProps> = ({ gaps, maxItems = 2 }) => {
  if (!gaps || gaps.length === 0) {
    return (
      <div className="bg-rose-50/30 border border-rose-100/50 p-4 rounded-xl">
        <h4 className="text-[10px] font-black text-rose-600 uppercase tracking-widest mb-2">Service Gaps</h4>
        <p className="text-[11px] text-rose-900 font-bold italic">No gaps identified</p>
      </div>
    );
  }

  return (
    <div className="bg-rose-50/30 border border-rose-100/50 p-4 rounded-xl">
      <h4 className="text-[10px] font-black text-rose-600 uppercase tracking-widest mb-2">Service Gaps</h4>
      <ul className="space-y-1.5">
        {gaps.slice(0, maxItems).map((gap, i) => (
          <li key={i} className="text-[11px] text-rose-900 font-bold leading-tight flex gap-1.5">
            <span className="text-rose-400 shrink-0">•</span>
            <span>{gap}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ServiceGapsCard;
